import { createSlice } from '@reduxjs/toolkit';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/purchaseInsurance/review',
  initialState: {
    isValid: false,
    hasProvidedInfo: false
  },
  reducers: {
    setValidity: (state, { payload }) => {
      state.isValid = payload;
    },
    setHasProvidedInfo: (state, { payload }) => {
      state.hasProvidedInfo = payload;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const setValidity = (isValid) => (dispatch) => {
  dispatch(actions.setValidity(isValid));
};

export const setHasProvidedInfo = (hasProvidedInfo) => (dispatch) => {
  dispatch(actions.setHasProvidedInfo(hasProvidedInfo));
};
